const style = {
  body: {
    userSelect: 'none',
    margin: '4px',
    padding: '8px 6px',
    border: '1px solid #c4c4c4',
    backgroundColor: '#ffffff',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
  },

  controls: {
    alignSelf: 'start',
    marginTop: '3px',
    display: 'flex',
  },

  name: {
    color: '#ee4360',
    fontSize: '12px',
    marginRight: 'auto',
    '&:hover': {
      color: '#ee4360',
    },
  },

  memberSince: {
    fontWeight: '400',
    fontSize: '10px',
    color: '#7f8fa4',
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
    paddingLeft: '3px',
    cursor: 'pointer',
    paddingRight: '5px',
  },

  documentsList: {
    fontWeight: '400',
    fontSize: '10px',
    color: '#7f8fa4',
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
    paddingLeft: '3px',
    cursor: 'pointer',
    paddingRight: '5px',
    display: 'flex',
  },

  documentsListCursor: {
    width: '8px',
    height: '12px',
    transform: 'rotate(-180deg)',
  },

  documentsListCursorOpen: {
    transform: 'rotate(90deg)',
  },

  deleteUser: {
    cursor: 'pointer',
    position: 'relative',
    top: '-4px',
    height: '10px',
  },

  handleDocumentsModalsCursor: {
    display: 'block',
    width: '15px',
    height: '14px',
    position: 'relative',
    bottom: '1px',
    cursor: 'pointer',
  },

  item: {
    display: 'flex',
    fontSize: '12px',
    padding: '5px 0px 0px',
    justifyContent: 'space-between',
  },

  documents: {
    fontSize: '12px',
    color: '#7F8FA4',
  },

  itemText: {
    color: '#7f8fa4',
  },

  itemStatus: {},
}

export default style



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/ColumnItem/style.js